<template>
  <v-select
    outlined
    hide-details
    :items="categorias"
    :value="value"
    item-text="DES_CATEGORIA"
    item-value="COD_ID_CATEGORIA_CLIENTE"
    @input="$emit('input', $event)"
  >
    <template #append>
      <mf-icon icon="keyboard_arrow_down" />
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    value: [String, Number],
  },
  computed: {
    ...mapState({
      stateCategoriasClientes: (state) => state.categoriasClientes,
    }),
    categorias() {
      const array = this.stateCategoriasClientes
      array.unshift({ COD_ID_CATEGORIA_CLIENTE: 'all', DES_CATEGORIA: 'Todos' })
      return array
    },
    selectedOption: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      },
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions(['categoriasClientes']),
    getData() {
      this.categoriasClientes()
    },
  },
}
</script>
